// PeptideVault v6.5 — Lab results + protocols

// ══════════════════════════════════════════════════════
// RENDER: LAB RESULTS TAB
// ══════════════════════════════════════════════════════

// ══════════════════════════════════════════════════════
// RENDER: PROTOCOLS TAB
// ══════════════════════════════════════════════════════
const FREQ_LABELS = {
  daily: 'Daily', eod: 'Every Other Day', mwf: 'Mon/Wed/Fri',
  weekly: 'Weekly', biweekly: 'Twice/Week', custom: 'Custom Days'
}
const WEEK_DAYS = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun']
// ── Washout calculator (used in half-life tab) ────────
function washoutTime(halfLife, ka, thresholdPct) {
  // Find t where batemanPct(t, hl, ka) <= threshold using binary search
  const ke = Math.LN2 / halfLife
  let lo = 0, hi = halfLife * 20
  for (let i = 0; i < 60; i++) {
    const mid = (lo + hi) / 2
    if (batemanPct(mid, halfLife, ka) > thresholdPct) lo = mid
    else hi = mid
  }
  return hi // hours until clearance
}

export {
  FREQ_LABELS,
  WEEK_DAYS,
  washoutTime
}
